<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { conditionInterpretator } from '../../helpers/scene_conditions_to_ui';
	import { format } from 'svelte-i18n';
	import type { DeviceConditionUI, DeviceTriggerUI } from '../../../../types/DeviceCondAndTriggerUI';
	import type { TimeBasedConditionsUI } from '../../../../types/TimeBasedConditionsUI';
	import SingleRowViewWithControls from './SingleRowViewWithControls.svelte';
	import { extract_conditions_variables } from './extract_conditions_variables';
	import type { AutomationConditionUI } from '../../../../types/AutomationConditionUI';
	import type { SunriseSunsetConditionUI } from '../../../../types/SunriseSunsetConditionUI';
	import type { WeatherConditionUI } from '../../../../types/WeatherConditionUI';
	import type { EnergyExchangeConditionUI } from 'src/types/EnergyExchangeConditionUI';

	import { Label, Stack } from '@Shelly/shelly-design-system';
	import type { MathConditionUI } from 'src/types/Scenes/MathConditionUI';

	export let element, //only condition types will be here
		self_ind = -1,
		main_ind = -1,
		type: 'and' | 'or' = 'and';

	const dispatch = createEventDispatcher();
	let purpose: string | undefined = element._gui_type || element._gui_purpose || undefined;

	let translated:
		| DeviceConditionUI
		| DeviceTriggerUI
		| TimeBasedConditionsUI
		| AutomationConditionUI
		| SunriseSunsetConditionUI
		| WeatherConditionUI
		| EnergyExchangeConditionUI
		| MathConditionUI
		| undefined = conditionInterpretator(element, purpose);

	const { title, withLabelList, labelList, conditionList, subtitle, avatar, description } =
		extract_conditions_variables(translated);
</script>

<SingleRowViewWithControls
	{element}
	{withLabelList}
	{labelList}
	{avatar}
	{title}
	{subtitle}
	{description}
	on:edit={(e) => {
		e.stopImmediatePropagation();
		dispatch('edit', { main_ind, sub_ind: self_ind, type });
	}}
	on:delete={(e) => {
		e.stopImmediatePropagation();
		dispatch('delete', { main_ind, sub_ind: self_ind, type });
	}}
/>

{#if conditionList && conditionList.length > 0}
	<Stack gap="s" class="mt-s">
		{#each conditionList as { icon, name }}
			<Label class="width-full justify-content-start" {icon} value={name} size="s" />
		{/each}
	</Stack>
{/if}
